import { HOME } from "../constants/testIds";
import Reveal from "../components/loadout/Reveal";
import Button from "../components/loadout/Button";
import { BUSINESS } from "../constants/business";

// [10] Assembly CTA strip — 220px desktop, white bg, two-column row.
export default function AssemblyStrip() {
  return (
    <section
      data-testid={HOME.assemblyStrip}
      className="bg-white py-14 md:py-16"
      style={{ minHeight: 220 }}
    >
      <div className="mx-auto max-w-[1440px] px-6 grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
        <Reveal>
          <h2 className="font-display text-[#0A0A0A] text-[28px] md:text-[36px] leading-[1.02] max-w-[520px]">
            Tell us your budget. We'll spec the build.
          </h2>
        </Reveal>
        <Reveal delay={80}>
          <div className="flex flex-col md:flex-row md:items-center gap-6">
            <p className="font-sans text-[15px] md:text-[16px] text-[#0A0A0A] leading-relaxed max-w-[420px]">
              Operators don't guess. They configure. Book a 15-minute consultation
              with our builds team.
            </p>
            <Button
              as="a"
              href={BUSINESS.calendly}
              target="_blank"
              rel="noreferrer noopener"
              variant="primary"
              data-testid={HOME.assemblyCta}
            >
              Schedule Consult →
            </Button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
